import { Role } from './roles.interface'
import { MenuItems as DamMenuItems } from '@surgetech-eu/ewc-dam'
import {
    HandbookResolver,
    LabelResolver,
    MappingBaseMaterialComponent,
    OrganizationResolver,
    PackagingMaterialComponent
} from '@surgetech-eu/core'

export const EyedesRole: Role = {
    name: 'eyedes',
    title: 'Eyewear Designer',
    icon: 'ion-ios-glasses',
    pages: [
        {
            title: 'Prepare',
            name: 'prepare',
            icon: 'ion-settings',
            children: [
                {
                    name: 'prepareEyewear',
                    route: ['/', 'eyewear', 'prepare'],
                    title: 'Eyewear'
                },
                {
                    name: 'prepareCaseItems',
                    route: ['/', 'case', 'item', 'prepare'],
                    title: 'Case Item'
                },
                {
                    name: 'prepareCaseSets',
                    route: ['/', 'case', 'set', 'prepare'],
                    title: 'Case Set'
                }
            ]
        },
        {
            title: 'Manage',
            name: 'manage',
            icon: 'ion-ios-refresh',
            children: [
                {
                    route: ['/', 'eyewear', 'manage'],
                    name: 'prepareEyewear',
                    title: 'Eyewear'
                },
                {
                    name: 'prepareCaseItems',
                    route: ['/', 'case', 'item', 'manage'],
                    title: 'Case Item'
                },
                {
                    name: 'prepareCaseSets',
                    route: ['/', 'case', 'set', 'manage'],
                    title: 'Case Set'
                }
            ]
        },
        {
            title: 'Link',
            name: 'link',
            icon: 'ion-link',
            children: [
                {
                    route: ['/', 'case', 'set', 'link-item'],
                    name: 'linkCaseItems',
                    title: 'Case Set/Item'
                },
                {
                    name: 'linkCaseSets',
                    route: ['/', 'eyewear', 'link-case-set'],
                    title: 'Eyewear/Case Set'
                }
            ]
        },
        {
            title: 'Assign',
            name: 'assign',
            icon: 'ion-ios-pricetags',
            children: [
                {
                    route: ['/', 'eyewear', 'assign'],
                    name: 'assignEyewear',
                    title: 'Eyewear'
                },
                {
                    route: ['/', 'case', 'set', 'assign'],
                    name: 'assignSets',
                    title: 'Case Set'
                }
            ]
        },
        {
            title: 'Value Chain',
            name: 'value-chain',
            icon: 'ion-ios-paper',
            children: [
                {
                    route: ['/', 'value-chain', 'suggested-measurement'],
                    name: 'suggested-measures',
                    title: 'Suggested Measures'
                },
                {
                    route: ['/', 'value-chain', 'weight-calculation'],
                    name: 'weight-calculation',
                    title: 'Weight Reproportioning'
                },
                {
                    route: ['/', 'value-chain', 'monitoring'],
                    name: 'monitoring',
                    title: 'Monitoring'
                }
            ]
        },
        // {
        //   title: 'Propose',
        //   name: 'propose',
        //   icon: 'ion-ios-paper',
        //   children: [
        //     {
        //       name: 'acetate',
        //       route: ['/', 'propose', 'acetate'],
        //       title: 'Acetate'
        //     }
        //   ]
        // },
        {
            title: 'Certification',
            name: 'certification',
            icon: 'ion-document-text',
            children: [
                {
                    name: 'eyewearCertification',
                    route: ['/', 'eyewear', 'certification'],
                    title: 'Certification'
                },
                {
                    name: 'player',
                    route: ['/', 'eyewear', 'player'],
                    title: 'Player'
                }
            ]
        },
        {
            route: ['/', 'eyedes', 'history', 'case-set-link'],
            title: 'History',
            name: 'history',
            icon: 'ion-ios-clock'
        },
        {
            route: ['/', 'eyedes', 'mapping', 'base-material'],
            title: 'Base Material/Plating Material/Packaging Material',
            name: 'baseMaterial',
            icon: 'ion-ios-paper'
        },
        // {
        //     title: 'Linked',
        //     name: 'linked',
        //     icon: 'ion-link',
        //     children: [
        //       {
        //         name: 'linkedAcetate',
        //         route: ['/', 'eyewear', 'linked-acetate'],
        //         title: 'Acetate',
        //       },
        //       {
        //         name: 'linkedComponent',
        //         route: ['/', 'eyewear', 'linked-component'],
        //         title: 'Component',
        //       },
        //     ]
        //   },
        {
            title: 'SAP Integration',
            name: 'sap-integration',
            icon: 'ion-settings',
            children: [
                {
                    name: 'stagingArea',
                    route: ['/', 'sap-integration', 'staging-area'],
                    title: 'Staging Area'
                }
            ]
        },
        {
            title: 'User Management',
            name: 'user-management',
            route: ['/', 'user-management'],
            icon: 'ion-ios-people'
        },
        ...DamMenuItems,
        {
            title: 'Audit',
            name: 'audit',
            icon: 'ion-settings',
            children: [
                {
                    name: 'audit',
                    route: ['/', 'audit', 'dashboard'],
                    title: 'Dashboard'
                }
            ]
        }
    ],
    modules: {
        commonModules: [
            {
                path: 'eyewear',
                name: 'EyewearModule',
                load: () => import('../eyedes/eyewear/eyewear.module').then(m => m.EyewearModule)
            },
            {
                path: 'case',
                name: 'CaseModule',
                load: () => import('../eyedes/case/case.module').then(m => m.CaseModule)
            },
            {
                path: 'sap-integration',
                name: 'SapIntegrationModule',
                load: () => import('../eyedes/sap-integration/sap-integration.module').then(m => m.SapIntegrationModule)
            },
            {
                path: 'value-chain',
                name: 'ValueChainModule',
                load: () => import('../eyedes/value-chain/value-chain.module').then(m => m.ValueChainModule)
            },
            // {
            //     path: 'environmental-pnl',
            //     name: 'EnvironmentalModule',
            //     load: () =>
            //         import('../eyedes/environmental-pnl/environmental-pnl.module').then(m => m.EnvironmentalModule)
            // },
            {
                path: 'history',
                url: 'eyedes/history',
                name: 'HistoryModule',
                load: () => import('../eyedes/history/history.module').then(m => m.HistoryModule)
            },
            {
                path: 'sap-integration',
                name: 'SapIntegrationModule',
                load: () => import('../eyedes/sap-integration/sap-integration.module').then(m => m.SapIntegrationModule)
            },
            {
                path: 'user-management',
                name: 'UserManagementModule',
                load: () => import('../eyedes/user-management/user-management.module').then(m => m.UserManagementModule)
            },
            {
                path: 'audit',
                name: 'AuditModule',
                load: () => import('../eyedes/audit/audit.module').then(m => m.AuditModule)
            },
            {
                path: 'eyedes/mapping/packaging-material',
                name: 'SecondaryPackagingModule',
                load: () =>
                    import('../secondary-packaging/secondary-packaging.module').then(m => m.SecondaryPackagingModule)
            }
        ],
        externalModules: [
            {
                path: 'eyedes/mapping',
                childPath: 'base-material',
                component: MappingBaseMaterialComponent,
                resolve: {
                    handbook: HandbookResolver,
                    organizations: OrganizationResolver,
                    labels: LabelResolver
                },
                data: {
                    labelContexts: ['galvanicTreatment.certificationTable']
                }
            },
            {
                path: 'eyedes/mapping',
                childPath: 'plating-material',
                component: MappingBaseMaterialComponent,
                resolve: {
                    handbook: HandbookResolver,
                    organizations: OrganizationResolver,
                    labels: LabelResolver
                },
                data: {
                    labelContexts: ['galvanicTreatment.certificationTable']
                }
            },
            {
                path: 'secondary-packaging',
                childPath: 'packaging-material',
                component: PackagingMaterialComponent,
                resolve: {
                    handbook: HandbookResolver,
                    labels: LabelResolver
                },
                data: {
                    labelContexts: ['packagingMaterial.packagingMaterialTable']
                }
            }
        ]
    }
}
